import { useEffect, useState } from "react";
import { fetchActivity } from "@/lib/api";
import { UserPlus, Hammer, Calendar, Trophy, Crown } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

const ICON = { join: UserPlus, build: Hammer, event: Calendar, achievement: Trophy, rank: Crown };
const COLOR = { join: "#3ABEFF", build: "#FFBF00", event: "#FF8C00", achievement: "#FFBF00", rank: "#FF8C00" };

export default function ActivityFeed() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetchActivity().then(setItems).catch(() => {}); }, []);
  return (
    <div className="rounded-2xl glass p-5 sm:p-6" data-testid="activity-feed">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[#FFBF00] mb-4">Recent Activity</div>
      <ul className="space-y-3">
        {items.slice(0, 10).map((a) => {
          const I = ICON[a.kind] || Trophy;
          const c = COLOR[a.kind] || "#FFBF00";
          let when = "";
          try { when = formatDistanceToNow(new Date(a.created_at), { addSuffix: true }); } catch (err) { console.debug("date fmt failed", err?.message); }
          return (
            <li key={a.id} className="flex items-start gap-3">
              <div
                className="w-8 h-8 rounded-md grid place-items-center shrink-0"
                style={{ background: `${c}22`, color: c }}
              >
                <I size={14} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm">
                  <span className="font-semibold text-white">{a.actor}</span>{" "}
                  <span className="text-white/60">{a.text}</span>
                </div>
                <div className="text-[10px] uppercase tracking-widest text-white/40 mt-0.5">{when}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
